import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.resize()
  }

  resize() {
    const el = this.inputTarget
    el.style.height = "auto"
    const minHeight = parseFloat(getComputedStyle(el).minHeight) || 0
    const contentHeight = el.scrollHeight
    el.style.height = Math.min(Math.max(contentHeight, minHeight), 192) + "px"
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      if (this.inputTarget.value.trim().length > 0) {
        this.element.requestSubmit()
      }
    }
  }

  clearOnSuccess(event) {
    if (event.detail?.success) {
      this.inputTarget.value = ""
      this.resize()
    }
  }
}
